
import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import { setupManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import CustomerTypesForm from "./Form";

import { CustomerTypesQuery } from "../../../data/Axios/queries";

const base_url = setupManagementUrl.uri;
//const base_url = "https://localhost:7210/graphql/";
const actions = {
  entity: "CustomerTypes",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "customerTypeIds",
    inputObjectName: "bulkActivateDeactivateCustomerTypes",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus:true,
};
function CustomerTypesTable() {
const ignore =["isActive"]
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="CustomerTypes"
          subtitle="Manage CustomerTypes"
          ignoreFields={ignore}
          FormComponent={CustomerTypesForm}
          query={CustomerTypesQuery}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default CustomerTypesTable;
